import React from 'react';

import { PersonalCallRecordings } from 'src/lib/resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CallRecording } from '@ragu-components/ord-types';

const CallRecordingsList = React.lazy(async () =>
  import('./CallRecordingsList').then((module) => ({ default: () => <module.CallRecordingsList scope='personal' /> }))
);

export const personalCallRecordingsResource: OrdResourceProps = {
  key: PersonalCallRecordings,
  name: PersonalCallRecordings,
  list: <CallRecordingsList />,
  options: {},
  recordRepresentation: (record: CallRecording): string =>
    `${record.caller_id_name ?? ''} (${record.caller_id_number ?? ''})`,
};
